'use client';

import { useGeo } from '@repo/ui/GeoTargeting/GeoProvider';
import RecapListSection, { type RecapListProps } from './RecapListSection';

export const GeoRecapList = (props: RecapListProps) => {
  const { regionCode } = useGeo();

  return <RecapListSection {...props} state={regionCode} />;
};
